import type { ProcessingConfig } from './image/models/processing-config.model';
import type { VideoProcessingConfig } from './video/models/video-processing-config.model';
// Be Aware this file is used by Angular and Node, so it cannot use platform Specific functions!
declare const btoa: (data: string) => string;

export function buildImageUrl(baseImageUrl: string, resize: ProcessingConfig | VideoProcessingConfig): string {
  const json: string = JSON.stringify(resize);
  const base64: string = base64Encode(json);
  return `${baseImageUrl}${baseImageUrl.includes('?') ? '&' : '?'}p=${encodeURIComponent(base64)}`;
}

function base64Encode(data: string): string {
  if (typeof btoa !== 'function') {
    return Buffer.from(data).toString('base64');
  } else {
    return btoa(data);
  }
}
